import { Record, Map } from 'immutable';
import User from './user';

const CommentRecord = Record({
  id: undefined,
  text: undefined,
  createdAt: undefined,
  user: User,
  _links: new Map(),
  _forms: new Map()
});

class Comment extends CommentRecord {

  constructor(props) {
    props.user = new User(props.user);

    super(props);
  }

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Comment;


// WEBPACK FOOTER //
// ./src/api/models/comment.js